/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorizedUserDTO
 */
export interface AuthorizedUserDTO {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedUserDTO
     */
    username: string;
}

/**
 * Check if a given object implements the AuthorizedUserDTO interface.
 */
export function instanceOfAuthorizedUserDTO(value: object): value is AuthorizedUserDTO {
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function AuthorizedUserDTOFromJSON(json: any): AuthorizedUserDTO {
    return AuthorizedUserDTOFromJSONTyped(json, false);
}

export function AuthorizedUserDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizedUserDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
    };
}

export function AuthorizedUserDTOToJSON(value?: AuthorizedUserDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'username': value['username'],
    };
}

